const validationPattern = '[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}'
const validationRegex = new RegExp(`^${validationPattern}$`)

export const validateEmail = (email: string): boolean => {
    return validationRegex.test(email)
}
